<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container grid-list-xl pt-0>
      <page-tool-bar
        show_search
        show_date_start
        show_date_end
        :loading="loader"
        :search.sync="search"
        :date_start.sync="date_start"
        :date_end.sync="date_end"
      >
      </page-tool-bar>

      <v-layout row wrap justify-center align-center>
        <v-flex xs12 md12>
          <table-thay-dong-ho-dien-nuoc
            :date_start="date_start"
            :date_end="date_end"
            :type="'W'"
            :search="search"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import TableThayDongHoDienNuoc from "Components/TableThayDongHoDienNuoc/TableThayDongHoDienNuoc";
import moment from 'moment'

export default {
  name: "thay-dong-ho-dien",
  components: {
    TableThayDongHoDienNuoc,
  },
  data() {
    return {
      search: "",
      date_start: moment().startOf('month').format('YYYY-MM-DD'),
      date_end: new Date().toISOString().substring(0, 10),
      loader: false,
    };
  },
};
</script>
